import { render, staticRenderFns } from "./TextCollapse.vue?vue&type=template&id=a67fc2be&scoped=true"
import script from "./TextCollapse.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextCollapse.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextCollapse.vue?vue&type=style&index=0&id=a67fc2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67fc2be",
  null
  
)

export default component.exports